// import React, { useState } from "react";
// import { useAuth } from "./AuthContext";
// import { FiLogOut } from "react-icons/fi";
// import { Modal, Button } from "react-bootstrap";
// import { Card, CardContent, Grid, Typography, Avatar, Box, IconButton, Tooltip } from "@mui/material";

// const Logout = () => {
//   const { logout } = useAuth();
//   const [showConfirmation, setShowConfirmation] = useState(false);

//   const handleLogout = () => setShowConfirmation(true);
//   const handleConfirmLogout = () => {
//     logout();
//     setShowConfirmation(false);
//   };
//   const handleCancelLogout = () => setShowConfirmation(false);

//   return (
//     <>
//       <Tooltip
//         title="Logout" arrow
//         componentsProps={{
//           tooltip: {
//             sx: {
//               backgroundColor: 'brown',
//               color: 'white',
//               border: '1px solid white',
//               fontWeight: 'bold',
//               boxShadow: 2,
//             },
//           },
//         }}
//       >
//         <button onClick={handleLogout} className="logout-button">
//           <FiLogOut />
//         </button>
//       </Tooltip>
//       <Modal
//         show={showConfirmation}
//         onHide={handleCancelLogout}
//         centered
//         backdrop="static"
//         keyboard={false}
//         className="logout-modal"
//       >
//         <Modal.Header closeButton className="border-0">
//           <Modal.Title className="fw-bold">Confirm Logout</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="text-muted fs-6">
//           Are you sure you want to logout from your account?
//         </Modal.Body>
//         <Modal.Footer className="border-0">
//           <Button
//             variant="outline-secondary"
//             onClick={handleCancelLogout}
//             className="rounded-pill px-4"
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="danger"
//             onClick={handleConfirmLogout}
//             className="rounded-pill px-4"
//           >
//             Logout
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default Logout;

import React, { useState } from "react";
import { useAuth } from "./AuthContext";
import { FiLogOut } from "react-icons/fi";
import {
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  Button, MenuItem
} from "@mui/material";

const Logout = ({ asMenuItem = false, onAfterLogout }) => {
  const { logout } = useAuth();
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleLogoutClick = () => setShowConfirmation(true);
  const handleConfirmLogout = () => {
    logout();
    setShowConfirmation(false);
    if (onAfterLogout) onAfterLogout(); // close menu after logout
  };
  const handleCancelLogout = () => setShowConfirmation(false);

  return (
    <>
      {asMenuItem ? (
        <MenuItem onClick={handleLogoutClick}>
          <FiLogOut style={{ marginRight: 8 }} /> Logout
        </MenuItem>
      ) : (
        <Button onClick={handleLogoutClick} startIcon={<FiLogOut style={{ color: 'white' }} />}>
          Logout
        </Button>
      )}

      <Dialog open={showConfirmation} onClose={handleCancelLogout}>
        <DialogTitle>Confirm Logout</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to logout from your account?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelLogout} variant="outlined">Cancel</Button>
          <Button onClick={handleConfirmLogout} color="error" variant="contained">Logout</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Logout;
